import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { StatusBadge } from '@dealstack/frontend/shared/components/StatusBadge/StatusBadge';
import { ProgrammeStatus } from '@dealstack/shared/lib/generated';
import { resolveStatusBadgeColors } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageInvestments/utils/statusStyling.helper.ts';
import type { CSSProperties } from 'react';

interface Props {
	programmeStatus?: ProgrammeStatus;
	style?: CSSProperties;
}

const PROGRAMME_STATUS_COLOR: Partial<Record<ProgrammeStatus, string>> = {
	[ProgrammeStatus.INACTIVE]: 'dark.4',
	[ProgrammeStatus.JOINER]: 'orange.8',
	[ProgrammeStatus.HOLDER]: 'teal.8',
	[ProgrammeStatus.LEAVER]: 'blue.6',
};

const InvestorProgrammeStatusBadge = ({ programmeStatus, style }: Props) => {
	const tMipManage = useTranslationMipManage();

	if (!programmeStatus) {
		return null;
	}

	const { color, textColor } = resolveStatusBadgeColors(
		PROGRAMME_STATUS_COLOR[programmeStatus] ?? 'dark.4'
	);
	const translatedStatus = tMipManage(
		`investors.table.programme_status.${programmeStatus.toLowerCase()}`
	);

	return (
		<StatusBadge text={translatedStatus} color={color} textColor={textColor} style={style} />
	);
};

export { InvestorProgrammeStatusBadge };
